<template>
  <div class="main-layout">
    <NavBar />
    <main class="main-content">
      <router-view />
    </main>
    <Footer />
    <chat-assistant />
    <!--<ScrollToTopButton />-->
  </div>
</template>

<script>
import NavBar from '../components/partials/NavBar.vue';
import Footer from '../components/partials/Footer.vue';
//import ScrollToTopButton from '../components/partials/ScrollToTopButton.vue';
import ChatAssistant from '../components/ChatAssistant.vue';

export default {
  components: {
    NavBar,
    Footer,
    ChatAssistant
  }
};
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1 0 auto;
}
</style>